export default "__VITE_ASSET__D0xAsQ2V__"